import React, { useState, useEffect } from 'react'
import { MuiSelect } from '../../../components'

const ProgressionDropdown = ({ onChange, data }) => {
  const [selectedValue, setSelectedValue] = useState('')

  const onChangeFunc = (value) => {
    const selectedObj = data.find((item) => item.value === value)
    const updatedDropdownData = data.map(item => {
      if(item.value === value) {
        return {...item, selected: true}
      }
      return {...item, selected: false}
    })
    setSelectedValue(value)
    onChange({selectedObj, updatedDropdownData})
  }

  useEffect(() => {
    const selectedObj = data.filter(item => item?.selected)
    if(selectedObj?.[0]?.selected) {
      setSelectedValue(selectedObj?.[0]?.value)
    } else {
      setSelectedValue('')
    }
  }, [])
  
  return (
    <>
      {data?.length && <MuiSelect
        styletype='themeV2'
        name='entityName'
        onChange={(e) => onChangeFunc(e.target.value)}
        data={data}
        menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
        variant={'outlined'}
        selectlabel='label'
        selectvalue='value'
        value={selectedValue}
        color='dark'
      />}
    </>
  )
}

export default ProgressionDropdown
